import { useContent } from "contexts/contentContext/contentContext";
import { useProfile } from "contexts/profileContext/profileContext";
import apiRequest from "utils/ApiRequest/apiRequest";
import styles from "./styles.module.scss";
import { useState } from "react";
import getRequest from "utils/ApiRequest/getRequest";

import Cookies from "universal-cookie";
import config from "config";
import { useToasts } from "react-toast-notifications";

const cookies = new Cookies();

interface DownloadSubUsersListI {
  className?: string;
}

export const DownloadSubUsersList = ({
  className = "",
}: DownloadSubUsersListI) => {
  const { getTextByKey } = useContent();
  const { getSubUsersCounts } = useProfile();
  const [isDataLoading, setIsDataLoading] = useState(false);
  const { addToast } = useToasts();

  const handleLoadCsv = () => {
    setIsDataLoading(true);
    apiRequest("SubUsers", "DownloadToCsvSubUsers")
      .then((res) => {
        if (res.status === "success") {
          const byteCharacters = atob(res.data?.encodedArray || "");
          const byteNumbers = new Array(byteCharacters.length)
            .fill(0)
            .map((_, i) => byteCharacters.charCodeAt(i));
          const byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray], { type: "text/csv" });
          const blobUrl = URL.createObjectURL(blob);

          const link = document.createElement("a");
          link.href = blobUrl;
          link.download = res.data?.FileName || "JumbomailUsersList";
          link.click();
          URL.revokeObjectURL(blobUrl);
          addToast(getTextByKey("subusers-list-export-success"), {
            appearance: "success",
          });
        }
      })
      .catch(() => {
        addToast(getTextByKey("subusers-list-export-error"), {
          appearance: "error",
        });
      })
      .finally(() => setIsDataLoading(false));
  };

  const handleLoadExcel = () => {
    setIsDataLoading(true);
    getRequest(
      "SubUsers",
      "DownloadToExcelSubUsers",
      undefined,
      "application/json",
      cookies.get(config.api.jumbomailApiAuthCookie),
      window.location.pathname.split("/")[1],
      null,
      true
    )
      .then(async (res) => {
        const blob = await res?.data?.blob?.();

        if (!blob) {
          return addToast(getTextByKey("subusers-list-export-error"), {
            appearance: "error",
          });
        }

        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = "JumbomailUsersList.xlsx";
        link.click();
        URL.revokeObjectURL(url);
        addToast(getTextByKey("subusers-list-export-success"), {
          appearance: "success",
        });
      })
      .finally(() => setIsDataLoading(false));
  };

  const isButtonDisabled = !getSubUsersCounts()?.all || isDataLoading;

  return (
    <div className={`${styles.subUsersList} ${className}`}>
      <h3 className={styles.subUsersListTitle}>{getTextByKey("export")}:</h3>
      <button
        disabled={isButtonDisabled}
        className={styles.subUsersListDownload}
        onClick={handleLoadExcel}
      >
        excel
      </button>
      <button
        disabled={isButtonDisabled}
        className={styles.subUsersListDownload}
        onClick={handleLoadCsv}
      >
        csv
      </button>
    </div>
  );
};
